(function () {
  // Ambient "falling star" effect used on the (now-removed) Shop-by-Size tiles
  // (see .aviiro-star-shower / .aviiro-falling-star in theme.liquid). Still used
  // for every accordion row's content panel (a closed row's panel is hidden, so
  // its stars only show, and start falling, once opened) — the title/header
  // group no longer gets a shower; that spot was handed to the heart shower
  // over the bundle options instead (addHeartShower below).
  var STAR_POSITIONS = [
    { left: '8%', delay: '0.1s', duration: '2.1s' },
    { left: '24%', delay: '0.9s', duration: '1.9s' },
    { left: '41%', delay: '0.3s', duration: '2.4s' },
    { left: '58%', delay: '1.4s', duration: '2.0s' },
    { left: '74%', delay: '0.6s', duration: '2.3s' },
    { left: '90%', delay: '1.1s', duration: '1.8s' }
  ];

  function fillShower(shower, glyph) {
    STAR_POSITIONS.forEach(function (position) {
      var star = document.createElement('span');
      star.className = 'aviiro-falling-star';
      star.style.left = position.left;
      star.style.animationDelay = position.delay;
      star.style.animationDuration = position.duration;
      star.textContent = glyph;
      shower.appendChild(star);
    });
  }

  function addStarShower() {
    // Excludes accordion_Av01 (guarantee/shipping/returns) — that one gets
    // the heart shower instead, to match the bundle picker and name fields
    // right above it.
    var containers = document.querySelectorAll(
      '[id$="__main"] .accordion:not([class*="__accordion_Av01"]) .details-content'
    );

    containers.forEach(function (container) {
      if (container.querySelector('.aviiro-star-shower')) return;

      var shower = document.createElement('div');
      shower.className = 'aviiro-star-shower is-active';
      shower.setAttribute('aria-hidden', 'true');
      fillShower(shower, '★');
      container.appendChild(shower);
    });
  }

  function addHeartShower() {
    // The bundle picker box, the "Add your names" boxed section (each
    // matched by its data-heart-shower hook), and accordion_Av01's row
    // panels (guarantee/shipping/returns), for the same romantic touch.
    var containers = document.querySelectorAll(
      '[id$="__main"] [data-heart-shower], [id$="__main"] .accordion[class*="__accordion_Av01"] .details-content'
    );

    containers.forEach(function (container) {
      if (container.querySelector('.aviiro-star-shower')) return;

      var shower = document.createElement('div');
      shower.className = 'aviiro-star-shower is-active';
      shower.setAttribute('aria-hidden', 'true');
      // The plain heart glyph renders as iOS's built-in red color emoji on
      // Safari/Chrome iOS, ignoring the CSS color below entirely — the
      // trailing U+FE0E variation selector forces the monochrome "text
      // presentation" form instead, which does respect color.
      fillShower(shower, '♥︎');
      container.appendChild(shower);
    });
  }

  function init() {
    addStarShower();
    addHeartShower();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
